import {IBaseEntity, BaseEntity} from 'app/blocks/model/base-entity.model';

export interface ISurveyReport extends IBaseEntity {
    id: number;
    surveyName: string;
    timeOfSurvey: string;
    surveyType: string;
    imageAvailable: boolean;
    fileAvailable: boolean;
    pdfAvailable: boolean;
    siteVisitId: number;
    organisation: string;
    locationPoint: string;
    driver: string;
    completionDateTime?: string;
}

export class SurveyReport extends BaseEntity implements ISurveyReport {
    public id: number;
    public surveyName: string;
    public timeOfSurvey: string;
    public surveyType: string;
    public imageAvailable: boolean;
    public fileAvailable: boolean;
    public pdfAvailable: boolean;
    public siteVisitId: number;
    public organisation: string;
    public locationPoint: string;
    public driver: string;
    public completionDateTime?: string;

    constructor(surveyReport?) {
        super();
        if (surveyReport) {
            this.id = surveyReport.id;
            this.surveyName = surveyReport.surveyName;
            this.timeOfSurvey = surveyReport.timeOfSurvey;
            this.surveyType = surveyReport.surveyType;
            this.imageAvailable = surveyReport.imageAvailable || false;
            this.fileAvailable = surveyReport.fileAvailable || false;
            this.pdfAvailable = surveyReport.pdfAvailable || false;
            this.siteVisitId = surveyReport.siteVisitId;
            this.organisation = surveyReport.organisation;
            this.locationPoint = surveyReport.locationPoint;
            this.driver = surveyReport.driver;
            this.completionDateTime = surveyReport.completionDateTime;
        }
    }

    clone(): SurveyReport {
        return new SurveyReport(this);
    }
}
